import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'Actions';
import { getItemListFromLoadList, getItemListFromRentalTransport } from 'HelperFunctions/routing';

class PrintDispatchSummary extends React.Component {
  state = {
    directions: null,
  };

  setDirections = (response) => {
    this.setState({
      directions: response,
    });
  };

  componentDidMount() {
    const { fetchTruckRoute, paramsId } = this.props;
    const id = paramsId || this.props.match.params.id;
    fetchTruckRoute(id);
  }

  getTransportList(rentalItems, type) {
    const itemMap = new Map();

    rentalItems.forEach((rentalItem) => {
      rentalItem
        .filter((item) => item.rentalTransportType === type)
        .flatMap((transport) => [
          ...transport.rentalItems,
          ...transport.rentalBundles,
          ...transport.rentalAddOns,
          ...transport.rentalAccessories,
        ])
        .forEach((item) => {
          if (itemMap.has(item.name)) {
            const existingItem = itemMap.get(item.name);
            existingItem.quantity += item.quantity;
          } else {
            itemMap.set(item.name, { ...item });
          }
        });
    });

    return Array.from(itemMap.values());
  }

  renderTable(list, type, fromLoadList = false) {
    const { fullInventorySheet } = this.props;

    const rows = list.map((item, index) => (
      <tr key={item.id ?? index} className='dispatchRow'>
        {!!fullInventorySheet && <td className='filled'>{item.quantity}</td>}
        <td className='filled'>{item.name}</td>
        <td className='empty'></td>
        <td className='empty'></td>
        <td className='empty'></td>
        <td className='empty'></td>
      </tr>
    ));

    return (
      <div className='dispatchSummaryTable'>
        {fromLoadList && (
          <div className='loadListTitle' style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>From Load List:</div>
        )}
        <table>
          <thead>
            <tr className='dispatchTransport'>
              <th>{type === 'drop_off' ? 'Drop Off' : 'Pick Up'}</th>
            </tr>
            <tr className='dispatchHeaders'>
              {!!fullInventorySheet && (
                <th className='caption' style={{ width: '10%' }}>
                  Qty
                </th>
              )}
              <th className='caption' style={{ width: '50%' }}>
                Name
              </th>
              <th className='caption align-center' style={{ width: '8%' }}>
                Out
              </th>
              <th className='caption align-center' style={{ width: '8%' }}>
                In
              </th>
              <th className='caption align-center' style={{ width: '10%' }}>
                Missing
              </th>
              <th className='caption align-center' style={{ width: '20%' }}>
                Initial
              </th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
        <div className='printSignature' style={{ width: '100%' }}>
          <div className='printContainer' style={{ fontSize: '1.2rem' }}>
            <label className='signatureTitle'>
              {type === 'drop_off' ? 'Check Out' : 'Check In'}
            </label>
            <label className='signatureLine' style={{ width: '47%' }}>
              Signature
            </label>
            <label className='signatureLine' style={{ width: '20%' }}>
              Date
            </label>
          </div>
          <p>
            I agree that I have {type === 'drop_off' ? 'delivered' : 'received'}{' '}
            all items listed above and that all items are in acceptable
            condition.
          </p>
        </div>
      </div>
    );
  }

  getLoadListTransportList(stops, type) {
    const itemMap = new Map();
    stops
      .filter((stop) => stop.rentalTransport?.transportType === type)
      .forEach((stop) => {
        const { items, accessories, addOns, bundles } = stop.rentalTransport?.hasLoadList
          ? getItemListFromLoadList(stop.loadList, stop.rentalTransport?.rental?.rentalBundles)
          : getItemListFromRentalTransport(stop.rentalTransport);
        [...items, ...accessories, ...addOns, ...bundles].forEach((item) => {
          if (itemMap.has(item.name)) {
            itemMap.get(item.name).quantity += item.quantity;
          } else {
            itemMap.set(item.name, { ...item });
          }
        });
      });
    return Array.from(itemMap.values());
  }

  render() {
    const { truckRoute, fullInventorySheet } = this.props;
    const { name} = truckRoute;
    let { rentalItems } = truckRoute;
    let deliveryDate;
    let dropOffTable;
    let pickUpTable;

    const stops = truckRoute.stops ?? [];
    const inLoadListMode = stops.some((stop) => stop.rentalTransport?.hasLoadList);

    if (inLoadListMode) {
      deliveryDate = truckRoute.deliveryDate;
      // Only label the table "From Load List:" when every contributing stop of that
      // transport type is in load list mode — otherwise the heading would misdescribe
      // the rental-sourced items mixed in from non-load-list stops.
      const allFromLoadList = (type) =>
        stops
          .filter((stop) => stop.rentalTransport?.transportType === type)
          .every((stop) => stop.rentalTransport?.hasLoadList);
      const dropOffList = this.getLoadListTransportList(stops, 'drop_off');
      const pickUpList = this.getLoadListTransportList(stops, 'pick_up');
      if (dropOffList.length > 0) dropOffTable = this.renderTable(dropOffList, 'drop_off', allFromLoadList('drop_off'));
      if (pickUpList.length > 0) pickUpTable = this.renderTable(pickUpList, 'pick_up', allFromLoadList('pick_up'));
    } else {
      let dropOffs = [];
      let pickUps = [];
      if (rentalItems.length > 0) {
        deliveryDate = truckRoute.deliveryDate;
        rentalItems.forEach((rentalItem) => {
          let dropOffItem = rentalItem.filter(item => item.rentalTransportType === 'drop_off');
          let pickUpItem = rentalItem.filter(item => item.rentalTransportType === 'pick_up');

          if (dropOffItem) {
            dropOffItem.forEach((dropOff) => dropOffs.push([
              ...dropOff.rentalItems,
              ...dropOff.rentalBundles,
              ...dropOff.rentalAddOns,
              ...dropOff.rentalAccessories
            ]));
          };

          if (pickUpItem) {
            pickUpItem.forEach((pickUp) => pickUps.push([
              ...pickUp.rentalItems,
              ...pickUp.rentalBundles,
              ...pickUp.rentalAddOns,
              ...pickUp.rentalAccessories
            ]));
          };
        });
      };

      if (dropOffs.length > 0) {
        const dropOffList = dropOffs.reduce((prev, curr) => {
          return prev.concat(curr);
        }, []);

        dropOffTable = this.renderTable(dropOffList, 'drop_off');
      };

      if (pickUps.length > 0) {
        const pickUpList = pickUps.reduce((prev, curr) => {
          return prev.concat(curr);
        }, []);

        pickUpTable = this.renderTable(pickUpList, 'pick_up');
      };
    }

    return (
      <div className='dispatchSummaryPrintWrapper'>
        <div>
          <div className='content'>
            <div className='header'>
              <h1>
                {!!fullInventorySheet
                  ? 'Full Inventory Sheet'
                  : 'Dispatch Summary'}
              </h1>
            </div>
            <div className='dispatchTruckDetails' style={{ marginTop: 60 }}>
              <div>
                <h2>{name}</h2>
                <span>Route Date: {deliveryDate}</span>
              </div>
              {dropOffTable}
              {pickUpTable}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { truckRoute, loading } = state.truckRoute;
  return { truckRoute, loading };
};

export default connect(mapStateToProps, actions)(PrintDispatchSummary);
